// CSS custom property references for each theme key.
// During Phase 2, default.js will import these values so that
// styled-components consume CSS custom properties instead of static hex values.
const tokens = {
  boxShadow: {
    default: 'var(--color-box-shadow-default)',
    xsmall: 'var(--color-box-shadow-xsmall)',
    small: 'var(--color-box-shadow-small)',
    medium: 'var(--color-box-shadow-medium)',
    mediumInverted: 'var(--color-box-shadow-medium-inverted)',
    large: 'var(--color-box-shadow-large)',
  },
  fontSize: {
    small: 'var(--font-size-small)',
    reduced: 'var(--font-size-reduced)',
    base: 'var(--font-size-base)',
    medium: 'var(--font-size-medium)',
    large: 'var(--font-size-large)',
    xlarge: 'var(--font-size-xlarge)',
  },
  overlay: {
    color: 'var(--color-overlay-color)',
  },
  colors: {
    black: 'var(--color-black)',
    blue700: 'var(--color-brand-dark-blue)',
    brandDarkGreen: 'var(--color-brand-secondary-dark)',
    defaultFontBlack: 'var(--color-text-color)',
    gray100: 'var(--color-gray100)',
    gray200: 'var(--color-gray200)',
    gray300: 'var(--color-gray300)',
    gray400: 'var(--color-gray400)',
    gray500: 'var(--color-gray500)',
    gray600: 'var(--color-gray600)',
    gray700: 'var(--color-gray700)',
    gray800: 'var(--color-gray800)',
    gray900: 'var(--color-gray900)',
    grayCoorsLight: 'var(--color-gray-coors-light)',
    green100: 'var(--color-green100)',
    green200: 'var(--color-green200)',
    green300: 'var(--color-green300)',
    green400: 'var(--color-green400)',
    green500: 'var(--color-green500)',
    green600: 'var(--color-green600)',
    green700: 'var(--color-green700)',
    eggShelleyBlue: 'var(--color-egg-shelley-blue)',
    purple100: 'var(--color-purple100)',
    purple200: 'var(--color-purple200)',
    purple300: 'var(--color-purple300)',
    purple400: 'var(--color-purple400)',
    purple500: 'var(--color-purple500)',
    purple600: 'var(--color-purple600)',
    purple700: 'var(--color-purple700)',
    red100: 'var(--color-red100)',
    red200: 'var(--color-red200)',
    red300: 'var(--color-red300)',
    red400: 'var(--color-red400)',
    red500: 'var(--color-red500)',
    red600: 'var(--color-red600)',
    red700: 'var(--color-red700)',
    suyderhoudOrange: 'var(--color-suyderhoud-orange)',
    white: 'var(--color-white)',
    yellow100: 'var(--color-yellow100)',
    yellow200: 'var(--color-yellow200)',
    yellow300: 'var(--color-yellow300)',
    yellow400: 'var(--color-yellow400)',
    yellow500: 'var(--color-yellow500)',
    yellow600: 'var(--color-yellow600)',
    yellow700: 'var(--color-yellow700)',
  },
};

export default tokens;
